import { IdToken, LogoutOptions, PopupConfigOptions, PopupLoginOptions, User,   } from "@auth0/auth0-react";
import { GiveButterWidget } from "./give-butter/GiveButterWidget";
import { IonBackButton, IonButtons, IonHeader, IonTitle, IonToolbar } from "@ionic/react";

const FIVE_MINUTES_IN_SECONDS = 5 * 60;

export class AuthProvider {
    init = () => {
        const idToken = window.localStorage.getItem('id');
        if (idToken){
            this.idToken = idToken;
            this.user = JSON.parse(atob(idToken.split('.')[1]));
        }
    }

    idToken?: string;

    user?: User;

    authenticate = async () => {
        await this.auth0.loginWithPopup({}, { timeoutInSeconds: FIVE_MINUTES_IN_SECONDS });
        const idToken = await this.auth0.getIdTokenClaims()
        if (idToken){
            window.localStorage.setItem('id', idToken.__raw);
            window.location.reload();
        }
    }

    logout = () => {
        window.localStorage.removeItem('id')

        this.auth0.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    }

    auth0!: {
        logout: (options?: LogoutOptions | undefined) => Promise<void>;
        getIdTokenClaims: () => Promise<IdToken | undefined>;
        loginWithPopup: (options?: PopupLoginOptions, config?: PopupConfigOptions) => Promise<void>;
    }

}

export const LightHeader: React.FC<{ title: string; }> = ({ title }) => {
    return (
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="start">
                    {/* TODO: not going where I expect */}
                    <IonBackButton defaultHref="#" />
                </IonButtons>
                <IonTitle>{title}</IonTitle>
            </IonToolbar>
        </IonHeader>
    );
}

export const HeaderAndNavigationBar: React.FC = () => {
    return (
        <header className="main-header clearfix" data-sticky_header="true">
            <section className="header-wrapper navgiation-wrapper">
                <div className="header-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 col-sm-12 header-col-logo">
                                <div className="header-logo logo">
                                    <a href="#">
                                        <img src="images/logo/logo.png" alt="Logo" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-8 hidden-xs">

                                <div className="row">


                                    <div className="col-md-4 col-sm-4 info-separotor">

                                        <div className="header-icon-box">
                                            <div className="icon-container">
                                                <i className="fa fa-people-group"></i>
                                            </div>
                                            <div className="text">
                                                <span className="head-heading">We can help you</span>
                                                <span className="head-content">
                                                    Start a new Team!
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="col-md-4 col-sm-4 info-separotor">
                                        <div className="header-icon-box">
                                            <div className="icon-container">
                                                <i className="fa fa-hand-holding-dollar"></i>
                                            </div>
                                            <div className="text">
                                                <span className="head-heading">We can help you</span>
                                                <span className="head-content">
                                                    Fund your Team!
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-4 info-separotor">
                                        <div className="header-icon-box">
                                            <div className="icon-container">
                                                <i className="fa fa-trophy"></i>
                                            </div>
                                            <div className="text">
                                                <span className="head-heading">Black Hills youth</span>
                                                <span className="head-content">
                                                    Discover a Passion!
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>

                </div>

                <div className="navbar navbar-default">
                    <div className="container clearfix">
                        <div className="navbar-collapse collapse pull-left">
                            <ul className="nav navbar-nav">
                                <li>
                                    <a href="#" className="link-active">Home</a>
                                </li>

                                <li>
                                    <a href="#?scroll=about-us">Mission</a>
                                </li>
                                <li>
                                    <a href="#?scroll=volunteers">Volunteers</a>
                                </li>
                                <li>
                                    <a href="#?scroll=sponsors">Sponsors</a>
                                </li>
                                <li>
                                    <a href="#?scroll=map">Teams</a>
                                </li>
                                <li>
                                    <a href="#?scroll=events">Events</a>
                                </li>

                                {/* <li>
                                    <a href="#contact">Contact Us</a>
                                </li> */}

                            </ul>
                        </div>
                        <div className="navbar-header pull-right">
                            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <div className="navbar-contact hidden-sm hidden-xs">
                                <ul>
                                    <li>
                                        <div style={{ display: 'inline-block', width: 122, margin: 10 }}>
                                            <GiveButterWidget id="LYz01g" />
                                        </div>
                                        <a
                                            className="btn btn-custom"
                                            href="https://forms.gle/yY2ZdddXBKjjtpEv7"
                                            target="_blank"
                                            style={{ marginBottom: 15 }}
                                        >
                                            Start a New Team
                                        </a>

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

        </header>
    )
}
